import { DataViewProps } from '../../view/common/DataView';
import { TaskExec } from '../mgmt/api';
import { useStatefulWebSocketListener } from '../WebSocketListener';

export const useTaskExecListener = function (
    props: DataViewProps<TaskExec>
) {
    const taskExec = props.data;
    const id = taskExec?.id;
    const finished = taskExec?.finished;

    return useStatefulWebSocketListener({
        ...props,
        endPoint: '/agent/websocket',
        topic: id && !finished && `/topic/taskExec/${id}` || undefined,
    });
};

